import { AxiosBase } from '@/api/axiosBase';

export const apiFromBafsy = new AxiosBase({
  baseURL: 'https://platform.bafsy.com',
  headers: {
    common: {
      Accept: 'application/json',
    },
  },
  withCredentials: false,
});
